import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

export function useOrgData() {
  const [workers, setWorkers] = useState([]);
  const [requirements, setRequirements] = useState([]);
  const [projects, setProjects] = useState([]);
  const [positions, setPositions] = useState([]);
  const [mandantes, setMandantes] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(() => {
    return Promise.all([
      api.get("/workers"),
      api.get("/requirements"),
      api.get("/projects"),
      api.get("/positions"),
      api.get("/mandantes"),
    ]).then(([w, r, p, pos, m]) => {
      setWorkers(w.data); setRequirements(r.data); setProjects(p.data); setPositions(pos.data); setMandantes(m.data);
    }).finally(() => setLoading(false));
  }, []);

  useEffect(() => { reload(); }, [reload]);
  return { workers, requirements, projects, positions, mandantes, loading, reload };
}
